<div class="evaluate" >
    <div class="evaluate_con" [ngClass]="excellentFlag === 0? 'active':'' " *ngIf="myComment" >
        <div class="title">顾问点评</div>
        <div class="techer_first"  >
          <!--                <p  [innerHtml]="myComment"></p>-->
          <pre  [innerHtml]="myComment"></pre>
        </div>
        <div class="inner" *ngIf="context" >
          <p>我的追问：</p>
          <pre class="my_inner" [innerHtml]="context" ></pre>
        </div>
        <div class="techer_second" *ngIf="myQuetionComment">
          <!--                <p  [innerHtml]="myQuetionComment"></p>-->
          <pre  [innerHtml]="myQuetionComment"></pre>
        </div>
<!--       <div class="img"></div>-->
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-evaluate/evaluate.html